import { Bell, Settings } from "lucide-react";
import { BiUser } from "react-icons/bi";
import { FaCarSide, FaRoad, FaCommentDots, FaWallet, FaTicketAlt, FaImage } from "react-icons/fa";
import {
  MdAdminPanelSettings,
  MdDashboard,
  MdDirectionsCar,
  MdPriceChange,
} from "react-icons/md";

export const sidebarItems = [
  {
    id: 1,
    label: "Dashboard",
    parent_id: null,
    icon: <MdDashboard size={20} />,
    module: "dashboard",
    order_index: 1,
    url: "/",
  },
  {
    id: 2,
    label: "Users",
    parent_id: null,
    icon: <BiUser size={20} />,
    module: "users",
    order_index: 2,
    url: "/users",
  },
  {
    id: 3,
    label: "Rides",
    parent_id: null,
    icon: <FaCarSide size={20} />,
    module: "rides",
    order_index: 3,
    url: "/rides",
  },
  {
    id: 4,
    label: "Long Rides",
    parent_id: null,
    icon: <FaRoad size={20} />,
    module: "long-rides",
    order_index: 4,
    url: "/long-rides",
  },
  {
    id: 5,
    label: "Complaints",
    parent_id: null,
    icon: <FaCommentDots size={20} />,
    module: "complaints",
    order_index: 5,
    url: "/complaints",
  },
  {
    id: 6,
    label: "Wallet",
    parent_id: null,
    icon: <FaWallet size={20} />,
    module: "wallet",
    order_index: 6,
    url: "/wallet-management",
  },
  {
    id: 7,
    label: "Pricing",
    parent_id: null,
    icon: <MdPriceChange size={20} />,
    module: "pricing",
    order_index: 7,
    url: "/pricing",
  },
  {
    id: 7.5,
    label: "Long Ride Pricing",
    parent_id: null,
    icon: <MdPriceChange size={20} />,
    module: "pricing",
    order_index: 8,
    url: "/longdrive-pricing",
  },
  {
    id: 7.6,
    label: "Offers & Coupons",
    parent_id: null,
    icon: <FaTicketAlt size={20} />,
    module: "pricing",
    order_index: 8.5,
    url: "/promotions",
  },
  {
    id: 7.7,
    label: "Banners",
    parent_id: null,
    icon: <FaImage size={20} />,
    module: "pricing",
    order_index: 8.7,
    url: "/banners",
  },
  {
    id: 8,
    label: "Admin",
    parent_id: null,
    icon: <MdAdminPanelSettings size={20} />,
    module: "admin",
    order_index: 9,
    url: "/admins",
  },
  {
    id: 9,
    label: "Vehicles",
    parent_id: null,
    icon: <MdDirectionsCar size={20} />,
    module: "vehicles",
    order_index: 10,
    url: "/vehicles",
  },
  {
    id: 10,
    label: "Notifications",
    parent_id: null,
    icon: <Bell size={20} />,
    module: "notifications",
    order_index: 11,
    url: "/notifications",
  },
  {
    id: 11,
    label: "Settings",
    parent_id: null,
    icon: <Settings size={20} />,
    module: "settings",
    order_index: 12,
    url: "/settings",
  },
];
